"use client";

import React from "react";
import Image, { StaticImageData } from "next/image";
import Lottie from "lottie-react";
import robotAnimation from "@/assets/images/robot-animate.json";
import Link from "next/link";

type AiTool = {
  label: string;
  url: string;
  subtext: string;
  subtext2: string;
  icon: StaticImageData;
};

interface AiToolsCardProps {
  aiToolsLinks?: AiTool[];
  divLinkLabel?: string;
  divLinkSubtext?: string;
  handleMouseLeave?: () => void;
}

const AiToolsCard: React.FC<AiToolsCardProps> = ({
  aiToolsLinks = [],
  divLinkLabel = "",
  divLinkSubtext = "",
  handleMouseLeave = () => {},
}) => {
  return (
    <div className="col-span-2 grid grid-cols-1 gap-x-4 gap-y-4">
      <div className="relative z-50 whitespace-nowrap">
        <div className="absolute -top-[14px] left-0 right-0 z-50 w-full">
          <p className="mx-auto w-fit rounded-full border border-dashed border-[#7ca5f7] bg-white px-4 py-1 text-xs font-semibold text-[#202020]">
            AI Tools
          </p>
        </div>
        <div className="relative overflow-hidden whitespace-nowrap rounded-lg border border-dashed border-[#7ca5f7] bg-[linear-gradient(180deg,#f0f4ff,#ffffff)] p-2">
          <div className="absolute -right-2 bottom-0 flex items-center justify-center gap-2 md:gap-[9px]" aria-hidden="true">
            <Lottie
              animationData={robotAnimation}
              loop
              className="h-16 w-16 md:h-[6rem] md:w-[6rem]"
            />
          </div>
          <div className="space-y-1 pt-1">
            {aiToolsLinks.map((tool) => (
              <Link
                key={tool.url}
                href={tool.url}
                className="flex cursor-pointer items-center gap-4 rounded-md p-1"
                onClick={handleMouseLeave}
              >
                <div className="flex items-center gap-2 md:gap-[9px]">
                  <Image
                    src={tool.icon || ""}
                    alt={tool.label || ""}
                    className="h-[1.5rem] w-[1.5rem]"
                    width={24}
                    height={24}
                  />
                  <div className="flex flex-col items-start">
                    <p className={divLinkLabel}>{tool.label}</p>
                    <p className={divLinkSubtext}>{tool.subtext2}</p>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AiToolsCard;
